import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Space } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { deleteItem, getItem } from '../../network/itemList';
import { useNavigate } from 'react-router-dom';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';

const ItemList = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteItem(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getItem] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getItem, searchText.key, searchText.value],
    queryFn: () =>
      getItem({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.item,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/edit-item-stock/${record.name}`);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeleteItem + ` (${record?.item_name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.item}
          </span>
        </Popconfirm>
      ),
      icon: <MdDelete style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.itemName,
      dataIndex: 'item_name',
      key: 'item_name',
      ...props({ key: 'item_name', name: t.itemName }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/edit-item-stock/${record?.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.itemCode,
      dataIndex: 'item_code',
      ...props({ key: 'item_code', name: t.itemCode }),
    },
    {
      title: t.itemGroups,
      dataIndex: 'item_group',
      ...props({ key: 'item_group', name: t.itemGroups }),
    },
    {
      title: t.salesItem,
      dataIndex: 'is_sales_item',
      key: 'is_sales_item',
      render: (text, record) => {
        return (
          <StatusTag
            status={record?.is_sales_item ? 'Available' : 'Not Available'}
          />
        );
      },
    },
    {
      title: t.purchaseItem,
      dataIndex: 'is_purchase_item',
      key: 'is_purchase_item',
      render: (text, record) => {
        return (
          <StatusTag
            status={record?.is_purchase_item ? 'Available' : 'Not Available'}
          />
        );
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/edit-item-stock/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.DeleteItem + ` (${record?.item_name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      <Heading title={t.Inventory} subTitle={t.Item} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        Placeholder={t.searchByName}
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              navigate('/add-item-stock');
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />
            {t.AddItem}
          </Button>
        }
      />
    </div>
  );
};

export default ItemList;
